import Actions from './Actions';
import Body from './Body';
import Content from './Content';
import Header from './Header';
import Progress from './Progress';
import Root from './Root';
import Step from './Step';

/** @deprecated Legacy MUI copy — migrate consumers to the Encore MultiStepDialog and delete. */
export const MultiStepDialogMui = {
  Root,
  Header,
  Step,
  Content,
  Progress,
  Actions,
  Body,
};
